import styled from "styled-components";
const TitlePill = ({ title }) => {
  return <Div>{title}</Div>;
};
export default TitlePill;
const Div = styled.div`
  justify-self: center;
  align-self: center;
  margin: 1rem 0;
  padding: 0.65rem 1.5rem;
  font-size: 1.2rem;
  font-weight: 700;
  background-color: ${({ theme }) => theme.colors?.dark};
  border-radius: 999px;
  color: white;
`;
